import {HTTP} from '@/services/HttpServices';
import {WeatherMapType} from '@/weather/WeatherModels';

const BASE_PATH = '/admin/weather/map-types';

export function listWeatherMapTypes(): Promise<WeatherMapType[]> {
  return HTTP.get(`${BASE_PATH}`);
}

export async function updateWeatherMapType(type: WeatherMapType): Promise<void> {
  await HTTP.put(`${BASE_PATH}/${type.id}`, type);
}

export function createWeatherMapType(type: WeatherMapType): Promise<WeatherMapType> {
  return HTTP.post(BASE_PATH, type);
}

export async function deleteWeatherMapType(id: number): Promise<void> {
  return HTTP.httpDelete(`${BASE_PATH}/${id}`);
}

export async function reorderWeatherMapTypes(newOrder: { id: number, displayOrder: number }[]): Promise<void> {
  await HTTP.post(`${BASE_PATH}/reorder`, {newOrder});
}
